import React, { useState, useEffect, useRef } from "react";
import TechOathDetails from "../page_components/notary/techoath_details";
import BackdropModal from "../components/modals/backdrop_modal";
import apiRequest from "../services/apiService";
import VideoCallNew from "./VideoCallNew";
import useSendPushNotification from "../hooks/useSendPushNotification";
import LoadingAnimation from "../components/Loading";
import TimeAgo from "../utils/timeAgo";
import Swal from "sweetalert2";


/* COMPONENTS */
import SpeedTester from "../components/SpeedTest";
import PermissionPrompt from "../components/PermissionPrompt"

/* UTILS */
import { playNotificationSound, stopNotificationSound } from "../utils/notificationSound";
import {getUserAvatarStatus} from "../utils/getUserAvatarStatus";


import Cookies from "js-cookie";

import useFetch from "../hooks/useFetch";

import { useAuth } from "../contexts/AuthContext";


// AMPLIFY
import { generateClient } from "aws-amplify/api";
import useModelData from "../hooks/useModelData";



// QUERIES FOR LIST
import { listTransactions, listTransactionLawyers,listChatMessage } from "../graphql/queries";


// SUBSCRIPTION FOR PINGING WEBSOCKET AND REAL-TIME UPDATES
import {
  // CHAT
  onCreateChatMessage,
  onUpdateChatMessage,
  onDeleteChatMessage,

  onUpdateChatNegotiation,


  // TRANSACTION
  onCreateTransaction,
  onUpdateTransaction,
  onDeleteTransaction,
} from "../graphql/subscriptions";


import {
  onCreateTransactionLawyer,
  onUpdateTransactionLawyer,
  onDeleteTransactionLawyer,
} from "../graphql/subscriptions";

// MUTATIONS FOR CREATE , UPDATE AND DELETE
import {

  // CHAT
  createChatMessage,
  updateChatMessage,
  deleteChatMessage,

  updateChatNegotiation,


  // TRANSACTION LAWYER
  createTransactionLawyer,
  updateTransactionLawyer,
  deleteTransactionLawyer,
  updateTransaction,
  createTransaction,
  deleteTransaction
} from "../graphql/mutations";


import TransactionTable from "../page_components/videocall_new/TransactionTable";
import TransactionTableOnSchedule from "../page_components/videocall_new/TransactionTableOnSchedule";
import Chat from "../page_components/chat/chat";

import { format } from "date-fns";

import { authToken, createMeeting } from "../page_components/videocall/API";

import { useNavigate } from 'react-router-dom';
import BackdropModalSmall from "../components/modals/backdrop_modal_small";


import Lottie from "react-lottie";
import * as lottie_bell from "../lottie/lottie_bell.json";
import * as lottie_failed from "../lottie/lottie_failed.json";

// CSS
import '../styles/animation.css'
import TransactionTableMini from "../page_components/videocall_new/TransactionTableMini";


import { Helmet } from "react-helmet";


const TransactionTicker = React.memo(({ transaction }) => {
  return (
    <div>
      <TimeAgo dateString={transaction.date_created} />
    </div>
  );
});

const TechOathAmplify = () => {


   useEffect(() => {
    if ("Notification" in window) {
      Notification.requestPermission();
    }
  }, []);


 

const showNotification = (title="Title", body="Body") => {
  if (Notification.permission === "granted") {
    const notification = new Notification(`${title}`, {
      body: body,
    });


    // Stop flashing when user clicks the notification or focuses window
    notification.onclick = () => {
      window.focus();
    };

  }
};




  const [wifiSpeed, setWifiSpeed] = useState(null);
  const handleSpeedChange = (speed) => {
    setWifiSpeed(speed);  // Store the speed in the parent's state
  };


  const {
    hasCameraPermission,
    hasLocationPermission,
  } = useAuth();

  const [microphoneGranted, setMicrophoneGranted] = useState(false);

  // Check mic permission on mount
  useEffect(() => {
    navigator.permissions?.query({ name: 'microphone' }).then((result) => {
      if (result.state === 'granted') {
        setMicrophoneGranted(true);
      } else {
        setMicrophoneGranted(false);
      }
    }).catch(() => setMicrophoneGranted(false));
  }, []);

  //const shouldShowPermissionModal = !hasCameraPermission || !microphoneGranted;
  //const shouldShowPermissionModal = !hasCameraPermission || !hasLocationPermission || !microphoneGranted;
  

const [showPermissionModal,setShowPermissionModal] = useState(false);


  useEffect(() => {
    if (hasCameraPermission && microphoneGranted) {
      setShowPermissionModal(false);
    }
    else {
      setShowPermissionModal(true);
    }

    //console.log("showPermissionModal",showPermissionModal);

  }, [hasCameraPermission, microphoneGranted])


  
  // useEffect(() => {
  //   // Define the function to prompt the user
  //   const handleBeforeUnload = (event) => {
  //     const message = "Are you sure you want to leave? Changes you made may not be saved.";
  //     event.returnValue = message;
  //     return message;
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);




  const API_URL = process.env.REACT_APP_API_URL;
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  const { user,location,errorLocation } = useAuth();
  

  const user_id = user.user_id;
  const fullname = `${user.first_name} ${user.last_name}`;
  const user_profile_photo = user.user_profile_photo;


   


  const [currentStatus, setCurrentStatus] = useState("");

  // FETCHING OLD FOR READY FOR OATH
  const [transactionsForOath, setTransactionsForOath] = useState([]);

  const navigate = useNavigate();


  
  const { updateItem } = useModelData({
    model: "Transaction",
    queries: {
      update: updateTransaction,
    },
    subscriptions: {
      onUpdate: onUpdateTransaction,
    }
  });


  const generateRandomString = (length = 4) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    
    for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};


  const [isGenerating, setIsGenerating] = useState(false);
  const handleGenerateMeeting = async (transaction) => {

    //console.log("Generating meeting for transaction:", transaction);

    setIsGenerating(true);
    const meetingId = await createMeeting({ token: authToken });
    const rand = generateRandomString();

    if(meetingId){
    const updateInput = {
        id          : transaction.id,
        meeting_id  : meetingId,
        meeting_pass: rand?.toUpperCase(),
      };
      await updateItem(updateInput);
      await sendPushNotification(transaction.registration_id, "", "Meeting ID", `Your meeting ID: ${meetingId} and Password is: ${rand?.toUpperCase()}`, "MEETING ID", "notification_user" );
    }
    else{
        Swal.fire({
                title: 'Error generating meeting id and password because token expired, please contact the administrator.',
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
                confirmButtonColor: '#03c3ec',
                cancelButtonColor: '#ff3e1d',
              });
    }

      setIsGenerating(false);
  };


  const [isWindowClosed, setIsWindowClosed] = useState(false);
  const newWindow = useRef(null);

  

  const LOCAL_STORAGE_KEY = "cachedTransactionIds";

  function loadCachedTransactionIds() {
    const data = localStorage.getItem(LOCAL_STORAGE_KEY);
    return data ? new Set(JSON.parse(data)) : new Set();
  }

  function saveCachedTransactionIds(set) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify([...set]));
  }


  const handleJoinMeeting = async(transaction) => {
   

      if (newWindow.current && !newWindow.current.closed) {
        newWindow.current.focus();
        //console.log("Window is already open, focused.");
        return;
      }
  
      const currentUrl = window.location.origin; // Get the base URL (http://localhost:3000)
      let relativeUrl = `/iusevolutione/vcp/${transaction.meeting_id}/${transaction.id}/${transaction.transaction_id}`;
      let fullUrl = `${currentUrl}${relativeUrl}`; // Concatenate
   


      const windowFeatures = "width=980,height=900,scrollbars=yes,resizable=yes";
  
      newWindow.current = window.open(fullUrl, "_blank", windowFeatures);
  
      const checkWindowClosed = setInterval(() => {
        if (newWindow.current && newWindow.current.closed) {
          setIsWindowClosed(true); // Mark window as closed
          clearInterval(checkWindowClosed); // Stop checking
          //console.log("Window is closed.");
        }
      }, 1000);

 


  
  }

  const handleGoToPage = (transaction) =>{
    navigate('/oath/add');
  }

  
      
 

  const { sendPushNotification, response, error } = useSendPushNotification();

  const handleDelete = (transaction) => {
    // WEBSOCKET NOTIF IF ACCEPTED
    //sendNotification('sendAdminTransaction', transaction.transaction_id, "FOR OATH");

    // PUSH NOTIF IF ACCEPTED
    const registration_id = transaction.user_transacted.registration_id;
    sendPushNotification(
      registration_id,
      "",
      "Application Accepted",
      `Your Application has been accepted, please wait for your meeting id`,
      "TEST",
      "notification_user"
    );

    // Add the transaction to the transactionsForOath array AND CHANGE the transaction_status to "FOR OATH"
    const updatedTransaction = {
      ...transaction,
      transaction_status: "FOR OATH",
    };
    setTransactionsForOath((prevTransactionsForOath) => [
      ...prevTransactionsForOath,
      updatedTransaction,
    ]);
  };

  const [adminBase64Image, setAdminBase64Image] = useState("");
  const handleAdminBase64 = (base64) => {
    setAdminBase64Image(base64);
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const [currentTransactionId, setCurrentTransactionId] = useState("");
  const [formData,setFormData] = useState({});
  const [modalContent,setModalContent] = useState('');




const [currentViewingTransaction,setCurrentViewingTransaction] = useState("");

  const createTransactionLawyerHandler = async (transaction) => {
  
      const input = {
        user_profile_id   : transaction.user_profile_id,
        document_status   : "VIEWING",
        transaction_id    : transaction.transaction_id,
        transaction_status: "WAITING",
        transaction_type  : "REQUEST",
        lawyer_name       : "ATTY. " + fullname?.toUpperCase(),
        document_price    : transaction.document_price,
        //document_price    : 0,
        created_by        : user_id,
        user_location     : location,
        user_profile_photo: user_profile_photo,
      };
  
      const user_profile_id = transaction.user_profile_id;
      const transaction_id = transaction.transaction_id;
  
      const filter = {
        created_by: { eq: user.user_id },
        transaction_id: { eq: transaction_id },
      };
  
      const variables = { filter };
  
      try {
        // Step 1: Check if the user already exists
        const checkTransactionLawyerAlreadyExists = await client.graphql({
          query: listTransactionLawyers,
          variables: variables,
        });
  
        //console.log("checkTransactionLawyerAlreadyExists", checkTransactionLawyerAlreadyExists);
  
        if (checkTransactionLawyerAlreadyExists.data.listTransactionLawyers.items.length > 0) {
          //console.log("User status already exists, updating...");
  
          const existingStatus = checkTransactionLawyerAlreadyExists.data.listTransactionLawyers.items[0];
          const checkIfAlreadyAcceptedByBothSides = checkTransactionLawyerAlreadyExists.data.listTransactionLawyers.items[0].transaction_status;
  
          if (checkIfAlreadyAcceptedByBothSides === "ACCEPTED") {
            setCurrentStatus(checkIfAlreadyAcceptedByBothSides);
          } else {
            const updateVariables = {
              input: {
                id: existingStatus.id, // The ID of the existing user status
                document_status: transaction.document_status, // New status to update
              },
              condition: {
                user_profile_id: { eq: transaction.user_profile_id },
                transaction_id: { eq: transaction.transaction_id }, // The condition to ensure we update the correct user
              },
            };
  
  
            setCurrentViewingTransaction(existingStatus.id);

  
            // Step 3: Call the update mutation
            const updateResponse = await client.graphql({
              query: updateTransactionLawyer, // The mutation to update the user status
              variables: updateVariables,
            });
            //console.log( "User status updated:", updateResponse.data.updateTransactionLawyer );
          }
  
          return;
        }
  
        // Step 3: If user doesn't exist, create a new user status
        const mutationVariables = { input };
        const mutationResponse = await client.graphql({
          query: createTransactionLawyer,
          variables: mutationVariables,
        });
  
        const newTransaction = mutationResponse.data.createTransactionLawyer;
  
        setCurrentViewingTransaction(newTransaction.id);
  
        //console.log("Lawyer Transaction created:", newTransaction);
      } catch (error) {
        console.error("Error handling user status:", error);
      }
    };


  const updateTransactioLawyer = async (transaction) => {
    //console.log("currentTransactionId",currentTransactionId);
    // const updateVariables = {
    //   input: {
    //     id: currentTransactionId,
    //     document_status: "VIEWING",
    //   },
    //   condition: {
    //     transaction_id: { eq: transaction_id },
    //   },
    // };

    // // Step 3: Call the update mutation
    // const updateResponse = await client.graphql({
    //   query: updateTransactionLawyer, // The mutation to update the user status
    //   variables: updateVariables,
    // });

    // //console.log(
    //   "User status updated:",
    //   updateResponse.data.updateTransactionLawyer
    // );
  };

 
  const handleViewDetails = (transaction) => {
    //console.log("asdasdasd",transaction);

    setModalContent('transaction_details');
    setSelectedItem(transaction);
    setCurrentTransactionId(transaction.transaction_id);
    setOpen(true);


    createTransactionLawyerHandler(transaction)
    // updateTransactioLawyer(transaction);
  };




  const [open, setOpen] = useState(false);

  const handleClose = () => {
    clearData();
    setOpen(false);


    handleDeleteTransactionLawyer(currentViewingTransaction);

  };

  const [mergedData, setMergedData] = useState([]);
  const handleMergedData = (data) => {
    setMergedData((prevImages) => {
      // Filter out items from prevImages that have a transaction_id in the new data IF EXISTING THEN REPLACE
      const filteredImages = prevImages.filter(
        (image) =>
          !data.some(
            (newItem) => newItem.transaction_id === image.transaction_id
          )
      );

      // Add the new data to the filteredImages
      const newImages = [...filteredImages, ...data];

      return newImages;
    });
  };

  const clearArray = () => {
    setMergedData([]);
  };
 



  // AMPLIFY - PENDING TRANSACTIONS
  

  const handleSearch = (value) => {
    const names = value
      .split(' ')  // Split by spaces (e.g., "John Doe" -> ["John", "Doe"])
      .map(name => name.toUpperCase());  // Convert each part to uppercase

    const dynamicFilter = {
      and: names.map(name => ({
        full_name: { contains: name }
      }))
    };

    updateFilter(dynamicFilter);
  };
 
//   const filterPending = {
//   and: [
//     { transaction_status: { ne: "RELEASED" } },
//     {
//       or: [
//         { lawyer_id: { eq: user_id } },
//         { lawyer_id: { eq: null } },
//         { lawyer_id: { eq: "" } }
//       ]
//     }
//   ]
// };


 

  const [showModal, setShowModal] = useState(false);
  const [newTransaction, setNewTransaction] = useState(null);
  const [cachedTransactionIds, setCachedTransactionIds] = useState(
    loadCachedTransactionIds()
  );





  // REJECTED TRANSACTIONS
   const filterRejected = {
    and: [
          { transaction_status: { eq: "REJECTED" } },
          { created_by: { eq: user_id } }
        ]
      };

   const { dataAmplify:rejectedTransactions } = useModelData({
    model: "TransactionLawyer",
    queries: {
      list: listTransactionLawyers,
      create: createTransactionLawyer,
      update: updateTransactionLawyer,
      delete: deleteTransactionLawyer,
    },
    subscriptions: {
      onCreate: onCreateTransactionLawyer,
      onUpdate: onUpdateTransactionLawyer,
      onDelete: onDeleteTransactionLawyer,
    },
    filter: filterRejected,
  });


  
 
const filterPending = {
  or: [


     {
      and: [
        { transaction_status: { eq: 'PENDING' } },
      ]
    },

    // Case 1: PENDING and lawyer_id = currentUserId
    {
      and: [
        { transaction_status: { eq: 'PENDING' } },
        { lawyer_id: { eq: user_id } }
      ]
    },
    // Case 2: PENDING and lawyer_id is null or empty
    {
      and: [
        { transaction_status: { eq: 'PENDING' } },
        {
          or:[
            {
              lawyer_id: { eq: "" },
              lawyer_id: { eq: null },
            }
          ]

        }
      ]
    },
    // Case 3: NOT PENDING and lawyer_id = currentUserId
    {
      and: [
        { transaction_status: { ne: 'PENDING' } },
        { lawyer_id: { eq: user_id } }
      ]
    }
  ]
};

const [deletedItem, setDeletedItem] = useState(null);
const [showModalDeletedItem, setShowModalDeletedItem] = useState(false);

  const { dataAmplify, loadingAmplify,updateFilter,deleteItem, onExternalDelete,latestCreatedItem } = useModelData({
    model: "Transaction", // Model name for context
    queries: {
      list: listTransactions,
      create: createTransaction,
      update: updateTransaction,
      delete: deleteTransaction,
    }, 
    subscriptions: {
      onCreate: onCreateTransaction,
      onUpdate: onUpdateTransaction,
      onDelete: onDeleteTransaction,
      onCreateChatMessage: onCreateChatMessage,
    },
    filter: filterPending,
  });

  useEffect(() => {
    if (onExternalDelete) {
      setDeletedItem(onExternalDelete);

      if(onExternalDelete?.transaction_id === selectedItem?.transaction_id){
        //console.log("selectedItem?.transaction_id",selectedItem?.transaction_id);
        //console.log("onExternalDelete?.transaction_id",onExternalDelete?.transaction_id);


        setShowModalDeletedItem(true);
        setShowModal(false)
        setOpen(false)
      }


      // Optionally auto-close the modal after 5 seconds
      // const timer = setTimeout(() => {
        // setShowModalDeletedItem(false);
        //setDeletedItem(null);
        
      // }, 5000);

      // return () => clearTimeout(timer);
 
    }
  }, [onExternalDelete]);



  
// 4. Filter only valid pending transactions



//  COMPARE TRANSACTIONS and REJECTED TRANSACTIONS and show only Transactions that is not in the REJECTED LIST
  // const [filteredTransactions, setFilteredTransactions] = useState([]);
  // useEffect(() => {
  //   if (dataAmplify && rejectedTransactions) {
  //     const filtered = dataAmplify.filter(tx =>
  //       !rejectedTransactions.some(rej =>
  //         rej.transaction_id === tx.transaction_id &&
  //         parseInt(rej.created_by) === parseInt(user_id)
  //       )
  //     );

  //     setFilteredTransactions(filtered);
  //   }

  //   //console.log(dataAmplify);
  //   //console.log(rejectedTransactions);
  // }, [dataAmplify, rejectedTransactions]);



// const pendingTransactions = dataAmplify.filter((transaction) =>
//   transaction.transaction_status !== "RELEASED" &&
//   transaction.transaction_type === "VIRTUAL" &&
//   (
//     transaction.lawyer_id === null || transaction.lawyer_id === "" ||
//     parseInt(transaction.lawyer_id) === parseInt(user_id)
//   )
// );

 
const pendingTransactions = dataAmplify
  .filter((transaction) =>
    transaction.transaction_status !== "RELEASED" &&
    transaction.transaction_type === "VIRTUAL" &&
    (
      transaction.lawyer_id === null || transaction.lawyer_id === "" ||
      parseInt(transaction.lawyer_id) === parseInt(user_id)
    )
    //  && getUserAvatarStatus(transaction.user_status_updatedAt) === "online"
  );


// 3. Only handle non-rejected, non-cached transactions
useEffect(() => {
  for (const tx of pendingTransactions) {

    // THIS CODE IS TO SHOW IF THE TRANSACTION ID IS IN THE CACHE IF NOT THEN CONTINUE, IF IN THE CACHE THEN IT WILL NOT SHOW NOTIF
    if (cachedTransactionIds.has(tx.transaction_id)) {
      continue;
    }

    const updatedCache = new Set(cachedTransactionIds);
    updatedCache.add(tx.transaction_id);
    setCachedTransactionIds(updatedCache);
    saveCachedTransactionIds(updatedCache);

    // console.log("tx",tx);

 
    // if (getUserAvatarStatus(tx.user_status_updatedAt) == "avatar-online") {

      //console.log("getUserAvatarStatus(tx.user_status_updatedAt)",getUserAvatarStatus(tx.user_status_updatedAt));
      //console.log("isSameDay(tx.user_status_updatedAt)",isSameDay(tx.user_status_updatedAt));

      //  if (isSameDay(tx.user_status_updatedAt)) {
      //   setNewTransaction(tx);
      //   if (!open) {
      //     setShowModal(true);
      //   }
      //   else {
      //     playClickSound();
      //   }

      //   break;

      //  }



    
    // }


  }

  //console.log("pendingTransactionspendingTransactions",pendingTransactions);
}, [pendingTransactions, rejectedTransactions]);


const [countdown, setCountdown] = useState(15);
 useEffect(() => {
    if (latestCreatedItem) {
        if (!open && !showModal) {
          setNewTransaction(latestCreatedItem);
          setCountdown(15);
          setShowModal(true);
          showNotification("Transaction","New Application has been created.")
        }
        else {
          playClickSound();
        }
    }
  }, [latestCreatedItem]);


const getProgressColor = (seconds) => {
  if (seconds >= 10) return 'bg-primary';
  if (seconds >= 5) return 'bg-warning';
  return 'bg-danger';
};



useEffect(() => {
  let timer;
  if (showModal && countdown > 0) {
    timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
  }

  if (countdown === 0) {
    setShowModal(false);
    setNewTransaction(null);
  }

  return () => clearInterval(timer);
}, [showModal, countdown]);



  const playClickSound = () => {
    const clickSound = new Audio('/iusevolutione/assets/audio/notification.mp3'); // Provide path to your click sound
    clickSound.play();
  };
  


  useEffect(() => {
    if (showModal) {
      playNotificationSound();
    } else {
      stopNotificationSound();
    }
  }, [showModal]);






  // Filter Accepted Transactions (done in parent) for the current user
  const acceptedTransactions = dataAmplify.filter(
    (transaction) =>
      transaction.transaction_status === "RELEASED" &&
      parseInt(transaction.lawyer_id) === parseInt(user_id)
  );


  const onScheduleTransactions = dataAmplify.filter(
    (transaction) => 
      // transaction.transaction_status === "PENDING" &&
      transaction.transaction_type==="WALK-IN" &&
      parseInt(transaction.lawyer_id) === parseInt(user_id)
  );


 


 
  // IN PERSON / WALK-INS
 

  /*
  const [filterPendingWalkins, setFilterPendingWalkins] = useState({
    lawyer_id         : { eq: user_id },
    transaction_type  : { eq: "WALK-IN" },
  });


  const { dataAmplify:dataAmplifyWalkins, loadingAmplify:loadingAmplifyWalkins,refetch } = useModelData({
    model: "Transaction",
    queries: {
      list: listTransactions,
    },
    subscriptions: {
      onCreate: onCreateTransaction,
      onUpdate: onUpdateTransaction,
      onDelete: onDeleteTransaction,
    },
    filter: filterPendingWalkins
  });
  
  const scheduledTransactions = dataAmplifyWalkins;*/

  

  // const filterChat = {
  //   // transaction_id  : { eq: selectedItem.transaction_id},
  // };

  const [filterChat, setFilterChat] = useState({});

  const { dataAmplify:dataAmplifyChats, loadingAmplify:loadingAmplifyChat,refetch, clearData } = useModelData({
    model: "ChatMessage",
    queries: {
     // list: listChatMessage,
      list: null,
    },
    subscriptions: {
      onCreate: onCreateChatMessage,
      onUpdate: onUpdateChatMessage,
      onDelete: onDeleteChatMessage,
    },
    filter: filterChat,
    
    sortDirection: "DESC",
    sortField: "createdAt",
  });

  const client = generateClient();

  function handleChat(transaction){
    setModalContent('chat');
    setSelectedItem(transaction);
    setOpen(true);
  }


 
 

  if (loadingAmplify) {
    return <LoadingAnimation />;
  }


  async function handleDeleteTransactionLawyer(currentAcceptedTransactionLawyerId) {
    //console.log("currentAcceptedTransactionLawyerId",currentAcceptedTransactionLawyerId);
      const deleteTransactionVariables = {
        input: {
          id:currentAcceptedTransactionLawyerId
        },
      };

      try {
        const deleteResponse = await client.graphql({
          query: deleteTransactionLawyer, // The mutation to delete the transaction
          variables: deleteTransactionVariables,
        });
      } catch (error) {
        console.error("Error deleting transaction:", error);
      }

    setOpen(false);
  }



    // COMPLETED
    const additionalFieldsCompleted = [
      {
        label: 'RELEASED @',
        type: 'value',
        value: (transaction) => transaction.date_released || 'Default Value'
      }
      
    ];



    

    

    function handleTimeFormat(datetime){
      const dateObject = new Date(datetime);

      if (isNaN(dateObject)) {
        return "";
      }

      const formattedDate = format(dateObject, "MMMM dd, yyyy");
      const formattedTime = format(dateObject, "h:mm a");
      return `${formattedDate} ${formattedTime}`;
    }



  // VIRTUAL
  
  const additionalFieldsVirtual = [
    {
      title: 'Message',
      label: (transaction) => transaction.TransactionMessagesRelation?.items.length ?? 0,
      type: 'chat-button',
      onClick: (transaction) => handleChat(transaction),
      icon: 'bx bx-chat',
      color: 'warning',
    },

    {
      label: 'MEETING',
      type: 'value',
      value: (transaction) => transaction.meeting_id || ''
    },
    {
      label: 'PASSWORD',
      type: 'value',
      value: (transaction) => transaction.meeting_pass || ''
    },

 
    
    {
      title: 'GENERATE',
      label: 'Meeting',
      type: 'generate-meeting-button',
      // condition: (transaction) => transaction.meeting_id  === null ? false:true,
      condition: (transaction) => {
        // if (transaction.transaction_type.toLowerCase()==="walk-in") {
        //   return "walk-in";
        // }
        // else{
          if (!transaction.meeting_id && transaction.transaction_payment_status.toUpperCase()==="PAID") {
            return "generate";
          }
          else if (!transaction.meeting_id && transaction.transaction_payment_status.toUpperCase()==="UNPAID") {
            return "payment required";
          }
          else{
            return "join";
          }
        //}
      },
      // true: (transaction) => (
        
      // ),
      // false: (transaction) => (
      //   <button
      //     className={`btn btn-label-primary w-100`}
      //     onClick={() => handleGenerateMeeting(transaction)}>
      //       Generate
      //   </button>
      // ),
      onClickGenerate: (transaction) => handleGenerateMeeting(transaction),
      onClickJoin: (transaction) => {
        handleJoinMeeting(transaction);
      },
      onClickGoToPage: (transaction) => handleGoToPage(transaction),
      icon: 'bx bx-chat',
      color: 'warning',
      value: (transaction) => transaction.meeting_id || ''

    }
  

  ];


    const additionalFieldsVirtualMini = [
  
    {
      title: 'GENERATE MEETING',
      label: 'Meeting',
      type: 'generate-meeting-button',
      // condition: (transaction) => transaction.meeting_id  === null ? false:true,
      condition: (transaction) => {
        // if (transaction.transaction_type.toLowerCase()==="walk-in") {
        //   return "walk-in";
        // }
        // else{
          if (!transaction.meeting_id && transaction.transaction_payment_status.toUpperCase()==="PAID") {
            return "generate meeting";
          }
          else if (!transaction.meeting_id && transaction.transaction_payment_status.toUpperCase()==="UNPAID") {
            return "payment required";
          }
          else{
            return "join";
          }
      },
      onClickGenerate: (transaction) => handleGenerateMeeting(transaction),
      onClickJoin: (transaction) => {
        handleJoinMeeting(transaction);
      },
      onClickGoToPage: (transaction) => handleGoToPage(transaction),
      icon: 'bx bx-chat',
      color: 'warning',
      value: (transaction) => transaction.meeting_id || ''
    }
  

  ];




  // SCHEDULED
  const additionalFields = [
    {
      title: 'Chat',
      label: (transaction) => transaction.TransactionMessagesRelation?.items.length ?? 0,
      type: 'chat-button',
      onClick: (transaction) => handleChat(transaction),
      icon: 'bx bx-chat',
      color: 'primary',
    },
 
    {
      label: 'SCHEDULED@',
      type: 'value',
      value: (transaction) => handleTimeFormat(transaction.scheduled_at) || ''
    },
   

    /*
    {
      label: 'Custom Select',
      type: 'select',
      options: [
        { value: 'option1', label: 'Option 1' },
        { value: 'option2', label: 'Option 2' }
      ],
      onChange: (e, transaction) => //console.log(`Selected ${e.target.value} for transaction ${transaction.transaction_id}`)
    },
    {
      label: 'Custom Textbox',
      type: 'textbox',
      value: (transaction) => transaction.customField || '',
      onChange: (e, transaction) => //console.log(`Textbox value changed to ${e.target.value} for transaction ${transaction.transaction_id}`)
    }
      */

  ];

  
 const defaultOptionsLottieSuccess = {
    loop: true,
    autoplay: true,
    animationData: lottie_bell,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };


  const defaultOptionsLottieFailed = {
    loop: true,
    autoplay: true,
    animationData: lottie_failed,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };


  



  return (
    <>

      <Helmet>
        <title>ENOTARY - Home</title>
      </Helmet>



      <section className="pricing-free-trial bg-label-secondary top-0">


        {showPermissionModal &&
          <BackdropModalSmall open={showPermissionModal} handleClose={() => { setShowPermissionModal(false) }} modalTitle="Permission Required 🔐" >
            <PermissionPrompt setShowPermissionModal={setShowPermissionModal} />
          </BackdropModalSmall>
        }


        
        <div className="container d-none">
          <div className="position-relative">
            <div className="d-flex justify-content-between flex-column-reverse flex-lg-row align-items-center py-4 px-5">
              <div className="text-center text-lg-start  ms-3 d-none d-lg-block d-md-block">
               
                  {/* <h1>Hi</h1> */}
              
{/* 
                <div>
                  {location ? ( <p> Latitude: {location.latitude}, Longitude:{" "} {location.longitude} </p> ) : ( <p>Loading...</p> )}
                  {error ? <p>Error: {error}</p> : null}
                </div> */}

          

                 <button type="button"  className="btn btn-primary mt-4 mb-2 d-none"  onClick={showNotification}>Show Notification</button>

          

                
                {/* <SpeedTester callbackFunctionOnNetworkTest={handleSpeedChange}/>
                Your internet Speed: {wifiSpeed} Mbps */}




                

              </div>


              
              {/* <div className="text-center">
                <img src="/iusevolutione/assets/img/illustrations/lady-with-laptop-light.png" className="img-fluid me-lg-5 pe-lg-1 mb-3 mb-lg-0 scaleX-n1-rtl" alt="lady" data-app-light-img="illustrations/lady-with-laptop-light.png" data-app-dark-img="illustrations/lady-with-laptop-dark.png" height={202} />
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row  shadow-none rounded">
          
            <p className="fw-bold" style={{
              fontSize: "0.75rem",
              letterSpacing: "1px"
            }}>LIST OF PENDING TRANSACTIONS</p>

          <div className="col-12">
            <div className="nav-align-top mb-4">
              {/* <ul className="nav nav-tabs nav-fill" role="tablist">
                <li className="nav-item">
                  <button type="button" className="nav-link active" role="tab" data-bs-toggle="tab" data-bs-target="#navs-justified-home" aria-controls="navs-justified-home" aria-selected="true">
                    <i className="tf-icons bx bx-home me-1" /> Virtual
                    <span className="badge rounded-pill badge-center h-px-20 w-px-20 bg-label-danger ms-1">3</span>
                  </button>
                </li>
                <li className="nav-item">
                  <button type="button" className="nav-link" role="tab" data-bs-toggle="tab" data-bs-target="#navs-justified-profile" aria-controls="navs-justified-profile" aria-selected="false">
                    <i className="tf-icons bx bx-user me-1" /> Walk-ins (For Schedule)
                  </button>
                </li>
              </ul> */}
              <div className="tab-content p-0">
                <div className="tab-pane fade show active" id="navs-justified-home" role="tabpanel">


                  <div className="d-none d-md-block d-lg-block">

     
                <button type="button" onClick={()=>navigate('/oath/addwizard')} className="btn btn-warning mt-4 mb-2 d- ms-4" >
                  Create In-person Transaction
                </button>

                    <TransactionTable
                      transactions={pendingTransactions}
                      status="PENDING"
                      handleViewDetails={handleViewDetails}
                      selectedItem={selectedItem}
                      additionalFields={additionalFieldsVirtual}

                      handleSearch={handleSearch}
                    />
                  </div>


                  <div className="d-sm-block d-md-none d-lg-none">
                    <TransactionTableMini
                      transactions={pendingTransactions}
                      status="PENDING"
                      handleViewDetails={handleViewDetails}
                      selectedItem={selectedItem}
                      additionalFields={additionalFieldsVirtualMini}

                      handleSearch={handleSearch}
                    />
                  </div>


                </div>
                {/* <div className="tab-pane fade" id="navs-justified-profile" role="tabpanel">
                  <TransactionTable
                    // transactions={scheduledTransactions}
                    transactions={onScheduleTransactions}
                    status="SCHEDULED"
                    handleViewDetails={handleViewDetails}
                    additionalFields={additionalFields}
                    isGenerating={isGenerating}
                    handleSearch={handleSearch}
                  />
                </div> */}
              </div>
            </div>
          </div>








        </div>
      </div>
 
          
      {/* <section className="section-py first-section-pt mb-3 d-none">
        <div className="container">
           
          <div className="row mx-0 gy-3 px-4">
            <div className="col-md-12 mb-md-0 mb-4 p-0">
              <div className="card border rounded shadow-none">
                <div className="card-body">
                  <h3 className="card-title text-capitalize mb-1 text-info">
                    Completed Transactions
                  </h3>
                  <p className="">List of completed transactions</p>

                  <TransactionTable
                    transactions={acceptedTransactions}
                    status="RELEASED"
                    handleViewDetails={handleViewDetails}
                    additionalFields={additionalFieldsCompleted}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="mt-4 d-none">
        <div className="container">
          <div className="row mx-4 shadow-none rounded">

            <div className="col-12 bg-secondary rounded-top py-2  text-white">
              <span className="fs-4">
                On-scheduled Transactions
              </span>
              <p className="mb-0">List of on-scheduled transactions</p>
            </div>

            <div className="col-12 rounded bg-white px-0">
              <TransactionTable
                    // transactions={scheduledTransactions}
                    transactions={onScheduleTransactions}
                    status="SCHEDULED"
                    handleViewDetails={handleViewDetails}
                    additionalFields={additionalFields}
                    isGenerating={isGenerating}
                  />
            </div>
     
      
           
 
          </div>
        </div>
      </section> */}


      <div className="container-xxl flex-grow-1 container-p-y ">


        {showModalDeletedItem && deletedItem && deletedItem.transaction_id === selectedItem.transaction_id && (
          <BackdropModalSmall open={showModalDeletedItem} handleClose={() => { setShowModalDeletedItem(false) }} modalTitle="Canceled Transaction" >
            <div className="card px-sm-6 px-0 shake-with-pause">
              <div className="card-body">

                <div className="d-flex justify-content-center w-100">
                  <div className="" style={{ width: "150px", height: "150px" }}>
                    <Lottie
                      isClickToPauseDisabled={true}
                      options={defaultOptionsLottieFailed}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                </div>

                {/* Logo */}
                <div className="app-brand justify-content-center mb-6">
                    <span className="demo text-heading fw-bold fs-4" style={{letterSpacing:1.5}}>TRANSACTION CANCELLED !</span>
                </div>
                {/* /Logo */}

                <p className="text-start my-4 d-none">
                  Transaction has been called off.{deletedItem.transaction_id}
                </p> 
                <button type="button" className="btn btn-danger w-100 mt-4" onClick={()=>{ setShowModalDeletedItem(false); }}> Close </button>
                 
              </div>
            </div>

          </BackdropModalSmall>
        )}











        {newTransaction && (
          <BackdropModalSmall open={showModal} handleClose={() => { setShowModal(false) }} modalTitle="New Transaction" >
            <div className="card px-sm-6 px-0 shake-with-pause">
              <div className="card-body">

                <div className="d-flex justify-content-center w-100">
                  <div className="" style={{ width: "150px", height: "150px" }}>
                    <Lottie
                      isClickToPauseDisabled={true}
                      options={defaultOptionsLottieSuccess}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>

               

             

                </div>




                {/* Logo */}
                <div className="app-brand justify-content-center mb-6">
                  <a href="index.html" className="app-brand-link gap-2">
                    <span className="demo text-heading fw-bold fs-4" style={{letterSpacing:1.5}}>NEW TRANSACTION !</span>
                  </a>
                </div>
                {/* /Logo */}

                <p className="text-start my-4">
                  You've received a new transaction. Please review and take action.{newTransaction.transaction_id}
                </p>

                
                   {/* Progress Bar */}
                  <div className="progress w-100" style={{ height: '10px', marginTop: '1rem' }}>
                    <div
                      className={`progress-bar ${getProgressColor(countdown)}`}
                      role="progressbar"
                      style={{
                        width: `${(countdown / 15) * 100}%`,
                        transition: 'width 1s linear',
                      }}
                    ></div>
                  </div>


                <button type="button" className="btn btn-warning w-100 my-2" onClick={()=>{
                    handleViewDetails(newTransaction);
                    setShowModal(false);
                  }}> View </button>
                <button type="button" className="btn btn-danger w-100" onClick={()=>{ setShowModal(false); }}> Skip for now </button>
                 
              </div>
            </div>

          </BackdropModalSmall>
        )}





        <BackdropModal
          open={open}
          handleClose={handleClose}
          modalTitle="Information"
          hasCloseButtonBelow={modalContent === "transaction_details" ? true : false}
          size="lg"
          >

          {modalContent === "transaction_details" ?
              <TechOathDetails
                selectedItem                  = {selectedItem}
                handleDelete                  = {handleDelete}
                currentTransactionId          = {currentTransactionId}
                handleDeleteTransactionLawyer = {handleDeleteTransactionLawyer}
                setOpen                       = {setOpen}
              />
            :
            <Chat selectedItem={selectedItem} chatMessages={dataAmplifyChats} />
          }

        </BackdropModal>
      </div>
    </>
  );
};
export default TechOathAmplify;
